export const CommonLsi = {
  loadMixin: {
    error: {
      cs: 'Data ze serveru nebylo možné načíst.',
      en: 'Data from server cannot be loaded.'
    }
  },
  vucMixin: {
    notAuthorized: {
      cs: 'Nemáte práva na zobrazení vizuálního případu užití.',
      en: 'You have not permission to show visual use case.'
    },
    serverConnection: {
      cs: 'Server je dočasně nedostupný.',
      en: 'Server is temporarily unavailable.'
    }
  }
};

export default CommonLsi;



// WEBPACK FOOTER //
// ./common/common-lsi.js